export function Custom_Encode_URL(url?: string) {
  if (url?.includes('/')) {
    return url?.replaceAll('/', '_')?.replaceAll(' ', '-');
  }
  return url?.replaceAll(' ', '-');
}

export function Custom_Decode_URL(url?: string) {
  if (url?.includes('_')) {
    return url?.replaceAll('_', '/')?.replaceAll('-', ' ');
  }
  return url?.replaceAll('-', ' ');
}

//-------------------------- SHARED ENUMS ------------------------------

//// *** RELEASE CONTROL *** /////
export enum Release {
  version = '2023.7.0',
  notes = 'https://onetakeda.atlassian.net/wiki/x/2AKsEgE',
}

//Artifacts -- Card Types
export enum CardType {
  document = 'Document',
  training = 'Training',
  process = 'Process',
}

export enum DocumentCategories {
  Processes = 'Processes',
  SOPs = 'SOPs',
  ToolsAndForms = 'TOOLs and FORMs',
  BusinessControlled = 'Business Controlled',
}

export enum newDocumentCategories {
  GoverningStandardProcess = 'Governing Standard & Process Document',
  KeyProcessGxP = 'Key Process GxP Documents',
  KeyProcessBusinessControlled = 'Key Process Business Controlled Documents',
  Referenced = 'Referenced Documents',
}

export enum RACI_ClassNames {
  TAK = 'TAK',
  CRO = 'CRO',
  oTAK = 'oTAK',
}

export enum BannerType {
  Top = 'Top',
  Page = 'Page',
}

export enum ZoomActions {
  ZoomIn = 'ZOOM_IN',
  ZoomOut = 'ZOOM_OUT',
}

export enum ArtifactPageType {
  Pins = 'My Pins',
  RecentlyViewed = 'Recently Viewed',
  All = 'All Process Documents',
}

export enum ChangePageType {
  HomePage = 'Home',
  ProcessPage = 'Process',
}

export enum PinTypes {
  Artifact = 'artifact',
  Process = 'process',
  Training = 'training',
}

export enum Extensions {
  doc = 'doc',
  docx = 'docx',
  ppt = 'ppt',
  pptx = 'pptx',
  pdf = 'pdf',
  txt = 'txt',
  xls = 'xls',
  xlsx = 'xlsx',
}

export enum LogoSize {
  Small = 'S',
  Large = 'L',
}

export enum ProcessGroup {
  clinical = 'Clinical',
  operations = 'Study/Site Operation',
  data = 'Data Processing & Statistical Analysis',
  submission = 'Submission',
}

export enum EPhases {
  asset = 'Asset Planning',
  studyPlanning = 'Study Planning',
  studyStart = 'Study Start Up',
  studyConduct = 'Study Conduct',
  studyCloseout = 'Study Closeout',
  report = 'Report Writing',
  submission = 'Submission Prep',
  postSub = 'Post-Submission',
}

export enum ERoles {
  R1 = 'Role 1',
  R2 = 'Role 2',
  R3 = 'Role 3',
  R4 = 'Role 4',
}

export enum RACI {
  R = 'R',
  A = 'A',
  C = 'C',
  I = 'I',
}

export enum E_QuickLinks {
  Updates = 'Process Updates',
  Pinned = 'Pinned',
  Recent = 'Recent',
  Help = 'ELEVATE Help',
  Faq = 'FAQ',
  TDOM = 'TTDOM Processes',
}

export enum ProcessTabs {
  Overview = 'Overview',
  Map = 'Process Map',
  RACI = 'RACI',
  Documents = 'Documents',
  // Learning = 'Learning',
}

export enum LogInType {
  Internal = 'Internal',
  External = 'External',
}

export enum ResourceTabs {
  FutureFit = 'Future Fit',
  TTDOM = 'TTDOM',
}

export enum ResourcePages {
  Resources = 'Resources',
  Partnerships = 'CRO Partnership Pages',
}

export enum ResourcePageRoutes {
  Resources = 'resources',
  Partnerships = 'CRO-partnerships',
}

// ------------------------- SHARED CONSTANTS -----------------------------

export const phaseColorsConstants = [
  {
    name: EPhases.asset,
    color: '#EA5532',
    abbr: 'AP',
  },
  {
    name: EPhases.studyPlanning,
    color: '#C23C54',
    abbr: 'SP',
  },
  {
    name: EPhases.studyStart,
    color: '#DA5283',
    abbr: 'SSU',
  },
  {
    name: EPhases.studyConduct,
    color: '#9B72B0',
    abbr: 'SC',
  },
  {
    name: EPhases.studyCloseout,
    color: '#4C9BCF',
    abbr: 'SCO',
  },
  {
    name: EPhases.report,
    color: '#51B1BF',
    abbr: 'RW',
  },
  {
    name: EPhases.submission,
    color: '#ABB436',
    abbr: 'SUB',
  },
  {
    name: EPhases.postSub,
    color: '#EBA800',
    abbr: 'PSUB',
  },
];

export const QuickLinks: Array<string> = [
  E_QuickLinks.TDOM,
  E_QuickLinks.Updates,
  E_QuickLinks.Pinned,
  E_QuickLinks.Recent,
  E_QuickLinks.Help,
  E_QuickLinks.Faq,
];

//For reseting State of current Phase
export const DefaultIPhase: IPhase = {
  name: '',
  desc: '',
  id: 0,
  mark_width: 0,
  sort_order: 0,
};

export const DefaultIProcess: IProcess = {
  name: '',
  desc: '',
  id: 0,
  phases: [],
  roles: [],
  process_id: '',
  process_order: 0,
  label: '',
  artifacts: [],
  category_group: '',
  category_group_order: 0,
  ui_mark_duration: 0,
  ui_mark_offset: 0,
  abbrev: '',
  owner_email: '',
  owner_name: '',
  parent_process: '',
  parent_process_id: 0,
  created_dt: '0000-00-00',
};

export const documentTypeMappings = {
  [DocumentCategories.Processes]: ['Process'],
  [DocumentCategories.SOPs]: ['SOP'],
  [DocumentCategories.ToolsAndForms]: ['Tool', 'Form', 'Training', 'Records', 'Standard'],
  [DocumentCategories.BusinessControlled]: ['Business Controlled'],
};

// ------------------------- SHARED TYPES -----------------------------
type Information = {
  id: number;
  name: string;
  desc?: string;
  //artifacts?: Array<IVideoCard | IDocumentCard>;
};

type ProcessRow = {
  row: number;
  processes: Array<IProcess>;
};

type RoleCategory = {
  name: string;
  abbrev: string;
  label?: string;
  level1?: string;
  level2?: string;
};

export type RoleClass = {
  id?: number;
  key: string;
  name: string;
};

export type allOPModels = {
  name: string;
  id: number;
  key: string;
  desc?: string;
};

export type allRoles = {
  roles: Array<IRole>;
  role_classes: Array<RoleClass>;
  role_categories: Array<RoleCategory>;
};

export type Steps = {
  step: IStep;
};
export type Processes = {
  process: IProcess;
};
export type Phases = {
  phase: IPhase;
};
export type Roles = {
  role: IRole;
};
export interface ProcessMaps {
  process_map: IProcessMap;
}
export interface ProcessMapNodes {
  processMapNode: IProcessMapNode;
}

export type Artifacts = {
  artifact: IArtifact;
};

export type raci = 'R' | 'A' | 'C' | 'I';

export type SearchResultProcess = {
  id: number;
  name: string;
  last_modified_dt: string;
  process_id: string;
  operating_models_list: string;
};

export type SearchResultArtifact = {
  id: number;
  key: string;
  docid: string;
  title: string;
  type: string;
  url: string;
  system?: string;
  owner?: string;
  created_dt: string;
  j_process_artifact: {
    process: SearchResultProcess;
    document_category: string;
  }[];
};

export type SearchResults = {
  processes: Array<SearchResultProcess>;
  artifacts: Array<SearchResultArtifact>;
};

//-------------------------- SHARED INTERFACES -------------------------

export interface IOperatingModel extends Information {
  key?: string;
  durationUnit?: number;
  phases: Array<Phases>;
  milestones?: Array<IMilestone>;
  functionalGroups?: Array<IFunctionalGroup>;
  roles?: Array<string>;
  update?: IUpdate;
  steps?: Array<Steps>;
  processes?: Array<Processes>;
  process_maps?: Array<ProcessMaps>;
}

export interface IFunctionalGroup {
  name: string;
  rows: Array<ProcessRow>;
}

export interface IPhase extends Information {
  sort_order: number;
  mark_width: number;
}

export interface IProcess extends Information {
  process_id: string;
  label: string;
  abbrev: string;
  process_order: number;
  category_group: string;
  category_group_order: number;
  ui_mark_offset: number;
  ui_mark_duration: number;
  ui_start_phase?: string;
  ui_end_phase?: string;
  phases: Array<Phases>;
  roles: Roles[];
  artifacts: Array<Artifacts>;
  created_dt: string;
  created_by?: string;
  last_modified_dt?: string;
  last_modified_by?: string;
  diagram_link?: string;
  update?: IUpdate;
  owner_name?: string;
  owner_email?: string;
  parent_process?: string;
  parent_process_id?: number;
  operating_models_list?: string;
  simplified_raci?: string;
}

export interface IProcessDetails {
  map: IProcessMapNodes;
  steps: Array<IStep>;
}

export interface IMilestone {
  key: string;
  name: string;
  ui_mark_duration: number;
  ui_mark_offset: number;
}

export interface IUpdate {
  id?: string;
  summary: string;
  lastModified: string; //ISO string for date
  lastModifier: string;
}

export interface IRole {
  id?: number;
  name: string;
  desc: string;
  key?: string;
  label?: string;
  role_class?: {
    name: string;
  };
  abbrev: string;
  class_name: string;
  role_category: RoleCategory;
}

// Artifacts -- Trainings(videos), Documents, Processes

export interface ITraining {
  id: number;
  key: string;
  title: string;
  desc?: string;
  level: number;
  source?: string;
  level_label: string;
  requirement: string;
  url?: string;
  type?: string;
  created_dt?: string;
  role_categories_list?: string;
  processes_list?: string;
}

export interface IArtifact {
  id: number;
  key: string;
  docid?: string | null;
  desc?: string;
  title: string;
  type: string;
  system?: string | null;
  url?: string | null;
  owner?: string | null;
  owner_email?: string | null;
  created_dt: string;
  eff_date?: string;
  j_process_artifact?: {
    process: processID;
    document_category: string;
  }[];
}

export interface ITrainingCard extends ITraining {
  card: CardType.training;
}

export interface IDocumentCard extends IArtifact {
  card: CardType.document;
  parent_process_id?: string | null;
}

export interface IProcessCard extends IArtifact {
  card: CardType.process;
}

//User

export interface IUserProfile {
  email: string;
  displayName?: string;
  firstName: string;
  lastName: string;
  timeZone: string;
  groups: Array<string>;
}

export interface IUser extends IUserProfile {
  id: number;
  release?: string;
  permissions: Array<IPermission>;
  userRoles: Array<Roles>;
  user_pin: Array<IUserPins>;
  organization?: string;
}

export interface IPermission {
  name: string;
  description: string;
}

export interface IUserPins {
  id: number;
  user_id: number;
  object_id: string;
  object_type: PinTypes;
  object_url?: string;
}

export interface processID {
  process_id?: string;
  id?: number;
  name?: string;
  last_modified_dt?: string;
}

export interface IUserPinArtifact {
  id: number;
  docid: string;
  key: string;
  title: string;
  type: string;
  system?: string;
  owner?: string;
  source_name?: string;
  url: string;
  created_dt: string;
  j_process_artifact: {
    process: processID;
    document_category: string;
  }[];
}

export interface IRaci {
  role: IRole;
  raci_list: string;
}

export interface IStep {
  key?: string;
  phase_key: string;
  process_key: string;
  comment: string;
  desc: string;
  details?: string;
  level: number;
  level_label?: string;
  order?: number;
  raci: Array<IRaci>;
  artifacts?: Array<Artifacts>;
  comment_flag?: string;
}
export interface IProcessMap {
  id: number;
  key: string;
  diagram_id: string;
  diagram_anchor: string;
  process_id: number;
  process_name: string;
  l1_label: string;
  l1_label_order: 1;
  l2_label?: string;
  l2_label_order: string;
  ref_node_id: number;
  ref_node_header: string;
  raci: Array<IRaci>;
  phases_list?: string;
  update?: string;
}

export interface IProcessMapNodes {
  process_map_node: Array<IProcessMapNode>;
}

export interface IProcessMapNode {
  id: number;
  node_type: string;
  node_id: string;
  position_x?: number;
  position_y?: number;
  position_in?: string;
  position_in_target?: string;
  position_out?: string;
  position_out_alt?: string;
  position_in_alt_target?: string;
  diagram_link: string;
  diagram_link_id: number;
  diagram_anchor: string;
  parent_label?: string;
  raci: Array<IRaci>;
  steps: Array<INodeStep>;
  parent_edge: Array<IEdge>;
  process_name: string;
  process_id: number;
  l1_label_order: number;
  sub_process_label?: string;
  update?: string;
  label?: string;
  header?: string;
}

export interface IEdge {
  child_node_path?: string;
  parent_node: {
    node_id: string;
    node_type: string;
  };
  child_node: {
    node_id: string;
    node_type: string;
  };
}
export interface INodeStep {
  step: {
    phase_key: string;
    process_key: string;
    comment: string;
    details?: string;
    level: number;
    desc: string;
    artifacts?: [];
    updates?: [];
  };
}

export interface INodeStepsDetails {
  id: string;
  description: string;
  roles: Array<IRaciRoleBadge>;
  steps: Array<IStepDetail>;
  update?: IUpdate;
  diagram_link?: string;
  position_in?: 'R' | 'L' | 'T' | 'B';
  position_out?: 'R' | 'L' | 'T' | 'B';
  position_x: number;
  position_y: number;
}

export interface IStepDetail {
  step: {
    artifacts?: Array<Artifacts>;
    raci: Array<IRaciRoleBadge>;
    comment?: string;
    desc: string;
    details: string;
    level: number;
    phase_key?: string;
    process_key?: string;
    updates?: Array<IUpdate>;
  };
}

export interface IRaciRoleBadge {
  raci_list: string;
  role: {
    abbrev: string;
    name: string;
    label?: string;
    desc?: string;
    role_category: {
      abbrev: string;
      name: string;
    };
  };
}

export interface IRoleBadge {
  abbrev: string;
  name: string;
}

export interface IRelease {
  release: string;
  created_dt: string;
}

export interface IChange {
  id: number;
  release: string;
  label: string;
  delta_value: string;
  delta_type: string;
  delta_ref: string;
  object: string;
  object_link: string;
  object_key: string;
  process_change?: [
    {
      process: {
        name: string;
        process_id: string;
        parent_process: string;
        roles: Array<Roles>;
      };
    },
  ];
  step_change?: [
    {
      step: {
        name: string;
        process_key: string;
        step_id: string;
        level_lablel: string;
        j_process_map_node_step?: [
          {
            process_map_node: {
              diagram_key: string;
            };
          },
        ];
        raci: Array<Roles>;
      };
    },
  ];
  change_role?: [
    {
      role: IRole;
    },
  ];
}

export interface IExternalIDUser {
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  language: string;
  password: string;
}
